import { Typography } from '@mui/material';
import * as React from 'react';
import { logoColor } from '../../../helpers/ImagesUtils';

const InfoEntidadComponent = () => {
  return (
    <div
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: [1],
      }}
    >
      <Typography
        variant="body1"
        noWrap
        sx={{
          display: 'flex',
          alignItems: 'center',
          fontWeight: 'bold',
          fontSize: 20,
        }}
      >
        <img
          src={logoColor}
          style={{ width: '60px', marginRight: '10px' }}
          alt="logoColor"
        />
      </Typography>
    </div>
  );
};

export default InfoEntidadComponent;
